export default "__VITE_ASSET__DsnslSxz__"